export const zoomScale = 1.35
